/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_CARDS_DATA(state, cardsData) {
    state.cardsData = cardsData
  },
  SET_CARD_DATA(state, payload) {
    state.cardsData[state.cardsData.findIndex(x => x.hash === payload.hash)] = payload.data
  },
  SET_NEED_RELOAD(state, payload) {
    state.needReload = payload
  },
  SET_MAIN_DIV_KEY(state) {
    state.mainDivKey = Math.random()
  },
  SET_VIEW_MODE(state, viewMode) {
    state.viewMode = viewMode
  },
  SET_DASHBOARD_SCREEN_SIZE(state, screenSize) {
    state.screenSize = screenSize
  },
  SET_LABEL_DATA(state, labelData) {
    state.labelData = labelData
  }
}
